export default {
  page: {
    HOME: '/',
    DASHBOARD: '/dashboard',
    REPORTS: '/reports',
    INTEGRATIONS: '/integrations',
    WORKLOAD_REPORT: '/workload-report',
    PRODUCTIVITY_REPORT: '/productivity-report',
    UTILIZATION_REPORT: '/utilization-report',
    DORA_REPORT: '/dora-report',
    PERSONAL_REPORT: '/personal-report',
    INTEGRATION_DETAILS: '/integrations/:tenantID',
    SCHEDULES_BY_TENANT_ID: '/integrations/:tenantID/schedules',
    RULES_CONFIG: '/integrations/:tenantID/rules',
    PULL_REQUESTS: '/pull-requests',
    DEVELOPER_COMPARISON: '/developer-comparison',
  },
  name: {
    HOME: 'Home',
    DASHBOARD: 'Dashboard',
    REPORTS: 'Reports',
    INTEGRATIONS: 'Integrations',
    WORKLOAD_REPORT: 'Workload Report',
    PRODUCTIVITY_REPORT: 'Productivity Report',
    UTILIZATION_REPORT: 'Utilization Report',
    DORA_REPORT: 'DORA Report',
    PERSONAL_REPORT: 'Personal Report',
    INTEGRATION_DETAILS: 'Integration Details',
    SCHEDULES_BY_TENANT_ID: 'Schedules',
    RULES_CONFIG: 'Rules Config',
    PULL_REQUESTS: 'Pull Requests',
    DEVELOPER_COMPARISON: 'Developer Comparison',
  },
  api: {
    ROOT: process.env.SWAT_BOT_API_SERVER,
    integration: {
      GET_ALL: 'tenants',
      GET_ALL_BY_USER: 'tenants/tenants-of-user',
      ADD: 'tenants',
      GET_BY_ID: 'tenants/{id}',
      UPDATE: 'tenants/{id}/update',
      UPDATE_RULES: 'tenants/{id}/update-rules',
      DELETE: 'tenants/{id}/delete',
      NEW_CLIENT_KEY: 'tenants/{id}/new-client-key',
      NEW_REGISTRATION_KEY: 'tenants/{id}/new-registration-key',
      NEW_MANAGER_REGISTRATION_KEY: 'tenants/{id}/new-manager-registration-key',
      WEBHOOK_ACCESS_KEY: 'tenants/{id}/webhook-access-key',
    },
    schedule: {
      GET_ALL: 'schedules',
      GET_BY_ID: 'schedules/{id}',
      ADD: 'schedules',
      DELETE: 'schedules/{id}/delete',
      UPDATE: 'schedules/{id}/update',
    },
    report: {
      GET_ALL: 'reports/overall-report',
      GET_COMMON_TENANTS: 'reports/common-tenants',
      MEMBER_TENANT: 'reports/member-tenant',
      GET_GIT_PRODUCTIVITY_REPORT: 'reports/git-productivity',
      GET_PRODUCTIVITY_REPORT: 'reports/productivity-report',
      GET_UTILIZATION_REPORT: 'reports/utilization-report',
      GET_PULL_REQUEST_REPORT: 'reports/pull-request-report',
      GET_DEV_COMPARISON_REPORT: 'reports/compare-user-report',
      GET_LANGUAGE_REPORT: 'reports/language-report',
      GET_DORA_REPORT: 'reports/dora-report',
      GET_DORA_METRIC: 'reports/dora-metric'
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/url-constant.js